import { NameValuePair } from "../models/base/NameValuePair";

const replace = (template: string, key: string, value: string): string => {
  const regex = `{${key}}`;
  return template.replace(new RegExp(regex, "g"), value);
};

export const format = (template: string, values: NameValuePair<string>): string => {
  return Object.keys(values).reduce((template, key) => {
    return replace(template, key, values[key]);
  }, template);
};

export const stringTemplate = {
  format,
};
